// Domain nouns that do NOT vary by sport (TERMINOLOGY.md §5). Sport-varying
// nouns (Game/Match, GP/MP, Court/Pitch) live in the sport pack's `terms`
// (./terms.ts); `useLabels().term()` reads both.
//
// The words are in the shared catalogue (src/i18n/catalogs/shared, #1118),
// so they follow the active language: read them through term() or
// glossary(). GLOSSARY is the English source, for code that needs it.

import { messages } from '@/i18n'
import { sharedMessages } from '@/i18n/catalogs/shared'
import sharedEn from '@/i18n/catalogs/shared/en'

export const GLOSSARY = sharedEn.glossary

export type GlossaryKey = keyof typeof GLOSSARY

/** The glossary in the active language. */
export function glossary(): typeof GLOSSARY {
  return messages(sharedMessages).glossary
}
